import { SdgId } from '@upright/common/model/output/scores/sdg-alignment/types';
import SDG01 from './SDG-01-no-poverty.svg';
import SDG02 from './SDG-02-zero-hunger.svg';
import SDG03 from './SDG-03-good-health-and-well-being.svg';
import SDG04 from './SDG-04-quality-education.svg';
import SDG05 from './SDG-05-gender-equality.svg';
import SDG06 from './SDG-06-clean-water-and-sanitation.svg';
import SDG07 from './SDG-07-affordable-and-clean-energy.svg';
import SDG08 from './SDG-08-decent-work-and-economic-growth.svg';
import SDG09 from './SDG-09-industry-innovation-and-infrastructure.svg';
import SDG10 from './SDG-10-reducint-inequalities.svg';
import SDG11 from './SDG-11-sustainable-cities-and-communities.svg';
import SDG12 from './SDG-12-responsible-consumption-and-production.svg';
import SDG12nt from './SDG-12-responsible-consumption-and-production-no-title.svg';
import SDG13 from './SDG-13-climate-action.svg';
import SDG14 from './SDG-14-life-below-water.svg';
import SDG15 from './SDG-15-life-on-land.svg';
import SDG16 from './SDG-16-peace-justice-and-strong-institutions.svg';
import SDG16nt from './SDG-16-peace-justice-and-strong-institutions-no-title.svg';
import SDG17 from './SDG-17-partherships-for-the-goals.svg';

/**
 * OA: The icons are originally from the official UN SDG page:
 * https://www.un.org/sustainabledevelopment/news/communications-material/
 * UN has them only in .png -format, so they have been vectorized using Figma.
 */
export function getSdgIcon(sdgId: SdgId) {
  const Icon = getSdgIconComponent(sdgId);
  return <Icon />;
}

/**
 * Get SDG icon component for SDG
 *
 * @param noThreeRowTitle when true, returns versions with no
 * text title for icons that have a title that spans three rows
 * (This is used by HorizontalSdgIcon)
 */
export function getSdgIconComponent(sdgId: SdgId, noThreeRowTitle?: boolean) {
  const Icon = (() => {
    switch (sdgId) {
      case SdgId._1_No_Poverty:
        return SDG01;
      case SdgId._2_Zero_Hunger:
        return SDG02;
      case SdgId._3_Good_Health_and_Wellbeing:
        return SDG03;
      case SdgId._4_Quality_Education:
        return SDG04;
      case SdgId._5_Gender_Equality:
        return SDG05;
      case SdgId._6_Clean_Water_and_Sanitation:
        return SDG06;
      case SdgId._7_Affordable_and_Clean_Energy:
        return SDG07;
      case SdgId._8_Decent_Work_and_Economic_Growth:
        return SDG08;
      case SdgId._9_Industry_Innovation_and_Infrastructure:
        return SDG09;
      case SdgId._10_Reduced_Inequality:
        return SDG10;
      case SdgId._11_Sustainable_Cities_and_Communities:
        return SDG11;
      case SdgId._12_Responsible_Consumption_and_Production:
        return noThreeRowTitle ? SDG12nt : SDG12;
      case SdgId._13_Climate_Action:
        return SDG13;
      case SdgId._14_Life_Below_Water:
        return SDG14;
      case SdgId._15_Life_on_Land:
        return SDG15;
      case SdgId._16_Peace_Justice_and_Strong_Institutions:
        return noThreeRowTitle ? SDG16nt : SDG16;
      case SdgId._17_Partnerships_for_the_Goals:
        return SDG17;
    }
  })();
  return Icon;
}
